"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableRow = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var react_1 = tslib_1.__importStar(require("react"));

var context_1 = require("../context");

var actions_heading_1 = require("../styled/actions-heading");

var row_1 = require("../styled/row");

var TableRow = function TableRow(_a) {
  var className = _a.className,
      __UIScope = _a.__UIScope,
      children = _a.children,
      _b = _a.isHeading,
      isHeading = _b === void 0 ? false : _b,
      rest = tslib_1.__rest(_a, ["className", "__UIScope", "children", "isHeading"]);

  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'TableRow',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;

  var _c = (0, react_1.useContext)(context_1.TableContext),
      isAlternating = _c.isAlternating,
      hasHighlights = _c.hasHighlights,
      hasActions = _c.hasActions;

  return react_1.default.createElement(row_1.Row, tslib_1.__assign({
    isHeading: isHeading,
    isAlternating: isAlternating,
    hasHighlights: hasHighlights,
    className: rootClasses
  }, rest), children, isHeading && hasActions && react_1.default.createElement(actions_heading_1.ActionsHeading, null, "Actions"));
};

var TableRowWithSpace = (0, ui_helper_with_space_1.withSpace)(TableRow);
exports.TableRow = TableRowWithSpace;